import { createSelector } from 'reselect';

export const getApprovedTasksId = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.approvedTasksId,
  (approvedTasksId) => {
    return approvedTasksId;
  }
);

export const getCurrentView = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.currentView,
  (review) => {
    return review;
  }
);

export const getEmails = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.emails,
  (emails) => {
    return emails;
  }
);

export const getMessage = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.message,
  (message) => {
    return message;
  }
);

export const getPdf = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.pdf,
  (pdf) => {
    return pdf;
  }
);

export const getShow = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.show,
  (show) => {
    return show;
  }
);

export const getShowApprovalConfirmation = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.budget.ui.showApprovalConfirmation,
  (showApprovalConfirmation) => {
    return showApprovalConfirmation;
  }
);

export const getShowApproveReviewModal = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.budget.ui.showApproveReviewModal,
  (showApproveReviewModal) => {
    return showApproveReviewModal;
  }
);

export const getShowEmailModal = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.showEmailModal,
  (showEmailModal) => {
    return showEmailModal;
  }
);

export const getShowPdfViewer = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.showPdfViewer,
  (showPdfViewer) => {
    return showPdfViewer;
  }
);

export const getSubject = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.subject,
  (subject) => {
    return subject;
  }
);

export const getUsers = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.data.users,
  (users) => {
    return users;
  }
);

export const getValuesByTaskId = createSelector(
  (state) => state.workOrders.scenes.details.scenes.budget.ui.valuesByTaskId,
  (valuesByTaskId) => {
    return valuesByTaskId;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/work-orders/details/budget.js